


class Smart_event{
	constructor(api, axios, helper){
		this.api   				= api;
		this.axios 				= axios;
		this.list_smart_event  	= [];
		this.list_points  		= [];
		this.list_tags 			= [];
		this.Helper  			= helper;
		this.get_list();
	}
	render(key, items){
		this.Helper.log({ key, items},"SMART EVENT class", 'RENDER');
		let vm = this;
		if (key == 'list_points') {
			if (items && items.length > 0) {
				items.forEach((it, idx_ix)=>{
					if (it) {
						vm.list_tags.push({
							id 	 : it.id,
							text : it.name
						});
						let temp_dev_alarm = it.Detail_device_alarm;
						if (temp_dev_alarm && temp_dev_alarm.length > 0 ) {
							temp_dev_alarm.forEach((dev_it, idx_rois)=>{
								if (dev_it && dev_it.detail_roi_device.length > 0) {
									dev_it.detail_roi_device.forEach((pts, idx_pts)=>{
										if (pts) {
											try {

												vm.list_points.push({
													name     :  "Roi " + it.name + " " + idx_pts + 1,
							                        point    :  JSON.parse(pts.points),
							                        deviceId :  dev_it.deviceId,
							                        ID 		 :  pts.id,
							                        active   :  false,
							                    });
							      	            
						                    }catch(e){
						                      console.log("error convert to json roi : ", e);
						                    }
										}
									}); // pts
								}
							}); // dev it
						} // len dev
					} // it
				});
			} // list points
			

		}else if (key == 'add_item') {
			let it = items;
			let temp_dev_alarm = it.Detail_device_alarm;
			if (temp_dev_alarm && temp_dev_alarm.length > 0 ) {
				temp_dev_alarm.forEach((dev_it, idx_rois)=>{
					if (dev_it && dev_it.detail_roi_device.length > 0) {
						dev_it.detail_roi_device.forEach((pts, idx_pts)=>{
							if (pts) {
								try {
									

									vm.list_points.push({
										name     :  "Roi " + it.name + " " + idx_pts + 1,
				                        point    :  JSON.parse(pts.points),
				                        deviceId :  dev_it.deviceId,
				                        ID 		 :  pts.id,
				                        active   :  false,
				                    });
									
				      	            
			                    }catch(e){
			                      console.log("error convert to json roi : ", e);
			                    }
							}
						}); // pts
					}
				}); // dev it
			} // len dev
			vm.list_smart_event.push(it);
			vm.list_tags.push({
				id 	 : it.id,
				text : it.name

			});
			
			// console.log("ADDED ITEMS", temp_dev_alarm);
		}
		else if (key == 'update_item') {
			const find = vm.list_smart_event.some((it, idx_ix)=>{
				if (it.id == items.id) {
					// console.log("COMPARE ITEMS : ", JSON.stringify(it) , (items))
					let idx_tag = vm.list_tags.findIndex(x => (x && x.id == it.id));
					if (idx_tag >= 0) {
						vm.list_tags[idx_tag].text = items.name;
					}

					it 						= items;
					let temp_dev_alarm 		= it.Detail_device_alarm;
					if (temp_dev_alarm && temp_dev_alarm.length > 0 ) {
						temp_dev_alarm.forEach((dev_it, idx_rois)=>{
							if (dev_it && dev_it.detail_roi_device.length > 0) {
								dev_it.detail_roi_device.forEach((pts, idx_pts)=>{
									if (pts) {
										try {
											let idx_f = vm.list_points.findIndex( f => (pts.id == f.ID));
											// console.log("update points class smart_events : ", idx_f, pts.points)
											if (idx_f >= 0) {
												vm.list_points[idx_f].point = JSON.parse(pts.points);
											}else{

												vm.list_points.push({
													name     :  "Roi " + it.name + " " + idx_pts + 1,
							                        point    :  JSON.parse(pts.points),
							                        deviceId :  dev_it.deviceId,
							                        ID 		 :  pts.id,
							                        active   :  false,
							                    });
											}
						      	            
					                    }catch(e){
					                      console.log("error convert to json roi : ", e);
					                    }
									}
								}); // pts
							}
						}); // dev it
					} // len dev
					return true
				} // it
			});
			// console.log("UPDATED ITEMS", this.list_points, this.list_smart_event);

		}
		// console.log("LIST POINTS :  **********************", this.list_points);
	} // render
	
	getListSmartEvent(){
		return this.list_smart_event;
	}
	get(key, list, option){
		if (list) {
			if (key && list  == 'list_points') {
				let vm = this;
				if (this.list_points && this.list_points.length > 0) {
					const filter = vm.list_points.filter( x =>{
						if (x && x.deviceId == key) {
							x.active = false;
							return true;
						}
					})
					return [ ...filter ]; 
				}
				return null;
			}else{
				if (option == "option_all") {					
					let temp = [ ...this.list_smart_event ];
					// temp.unshift({
					// 	id   : "all",
					// 	name : "All"
					// });
					return [...temp];

					// this.list_smart_event && this.list_smart_event.length > 0 ? [ ...this.list_smart_event] : [];	
				}else 
				if (option == "option_all_alert") {	
					let temp = this.list_smart_event.filter(x => x && x.Detail_action_alarm && x.Detail_action_alarm.length > 0 &&  x.Detail_action_alarm[0].isalert);
					temp.unshift({
						id   : "all",
						name : "All"
					});					
					return [...temp];				
				}else 
				if (option == "option_all_no_alert"){
					let temp = this.list_smart_event.filter(x => x && x.Detail_action_alarm && x.Detail_action_alarm.length > 0 &&  !x.Detail_action_alarm[0].isalert);
					temp.unshift({
						id   : "all",
						name : "All"
					});
					
					return [...temp];
				}

				return this.list_smart_event && this.list_smart_event.length > 0 ? [ ...this.list_smart_event] : null;
			}
		}

	}


	get_list(page = 1){
		const api = this.api.url + "/api/v1/alarm/?page=" + page;
		this.axios.get(api).then( res => {
			if (res &&  res.data ) {
				let items = res.data;
				if (items.rows && items.rows.length > 0) {

					this.list_smart_event = this.list_smart_event.concat(items.rows);
					
				}
				if (page < items.pages) {
					page++;
					this.get_list(page);
				}else{
					// console.log("LIST SMART EVENT : ", this.list_smart_event);
					this.render("list_points", this.list_smart_event)
				}
			}
		}).catch(er =>{
			console.log("Error get smart event ", er);
		})
	}
	get_tags(){
		return [...this.list_tags];
	}

	set(act, item, opt, pag){
		let vm = this;
		if (act == 'list_points') {
			console.log("update points global ",act, item, opt);

			if (item && item.id) {
				console.log("update points global list : ", vm.list_points)
				let idx = vm.list_points.findIndex( x => (x && x.ID == item.id));
				// console.log("update points global 1 ",idx);

				if (idx >= 0) {
					if (opt == 'delete') {
						vm.list_points.splice(idx, 1);
					}else{

						vm.list_points[idx].point = JSON.parse(item.points); 

					}
					// console.log("update points global 2",vm.list_points);
				}else{
					if (opt == 'create') {
						let len = 0; 
						if (vm.list_points && vm.list_points.length > 0) {
							len = vm.list_points.length - 1;
						}
						vm.list_points.push({
							name     :  "Roi " + 'added' + " " + len + 1,
	                        point    :  JSON.parse(item.points),	                        
	                        ID 		 :  item.id,
	                        active   :  false,
	                    });
					}
				}
			}

		}
		if (act == 'list_smart_event') {
			if (opt == 'delete_list') {
				this.list_smart_event 	= [];
				this.list_points 		= [];
				this.list_tags 			= [];
				if (item && item.length > 0) {
					this.list_smart_event = item;
					this.get_list(pag ++);

				}
			}

		}
		if (act == 'update_item' ||  act == 'add_item') {
			// console.log("class SMARTEVENT: ",item)
			if (item && item.id) {

			const api = this.api.url + '/api/v1/alarm/' + item.id;
			this.axios.get(api).then( res => {
					// console.log("Get Alarm class",res)
					let items = res.data;
					this.render(act, {...items});

				}).catch( er => {
					console.log("Error get Alarm class : ", er);
					
				})
			}else{
				console.warn("not found id get alarm class", item);
			}
		}

	}

	get_smart(ID, key = "id"){
		let idx = this.list_smart_event.findIndex(x =>(x && x[key] && x[key] == ID));  
		if (idx >= 0) {
			return { ...this.list_smart_event[idx]};
		}
		return null;
	}

	

}

export default Smart_event;